import { render, staticRenderFns } from "./FiltrosTipo1.vue?vue&type=template&id=37daa2f4&scoped=true&"
import script from "./FiltrosTipo1.vue?vue&type=script&lang=js&"
export * from "./FiltrosTipo1.vue?vue&type=script&lang=js&"
import style0 from "./FiltrosTipo1.vue?vue&type=style&index=0&id=37daa2f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37daa2f4",
  null
  
)

export default component.exports